import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(67, 90, 111, 0.699);\n'], ['\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(67, 90, 111, 0.699);\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n'], ['\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n  display: flex;\n  flex-direction: column;\n  max-width: calc(100vw - 16px);\n  max-height: calc(100vh - 16px);\n  width: ', ';\n  margin: 8px;\n  background: #fff;\n  border-radius: 8px;\n  animation: ', ' ', ' ', ' both;\n'], ['\n  ', ';\n  display: flex;\n  flex-direction: column;\n  max-width: calc(100vw - 16px);\n  max-height: calc(100vh - 16px);\n  width: ', ';\n  margin: 8px;\n  background: #fff;\n  border-radius: 8px;\n  animation: ', ' ', ' ', ' both;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(67, 90, 111, 0.079);\n'], ['\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(67, 90, 111, 0.079);\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0;\n  color: #1f4160;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n'], ['\n  margin: 0;\n  color: #1f4160;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  padding: 8px;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n'], ['\n  padding: 8px;\n  border: none;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  overflow-y: auto;\n  padding: 16px;\n  padding-bottom: 0;\n  min-height: 0;\n  font-size: 14px;\n  line-height: 1.2;\n\n  p {\n    margin: 0;\n    &:not(:last-child) {\n      margin-bottom: 0.7em;\n    }\n  }\n\n  a {\n    color: #47b881;\n    &:hover {\n      color: #64c395;\n    }\n    &:active {\n      color: #248953;\n    }\n  }\n'], ['\n  overflow-y: auto;\n  padding: 16px;\n  padding-bottom: 0;\n  min-height: 0;\n  font-size: 14px;\n  line-height: 1.2;\n\n  p {\n    margin: 0;\n    &:not(:last-child) {\n      margin-bottom: 0.7em;\n    }\n  }\n\n  a {\n    color: #47b881;\n    &:hover {\n      color: #64c395;\n    }\n    &:active {\n      color: #248953;\n    }\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  padding: 16px;\n  text-align: right;\n'], ['\n  padding: 16px;\n  text-align: right;\n']);

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'react-emotion';
import nanoid from 'nanoid';
import fontStyles from './font-styles';
var ANIMATION_DURATION = '200ms';
var ANIMATION_EASING = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
var Overlay = /*#__PURE__*/styled('div', {
  target: 'e160cov60',
  label: 'Overlay'
})(_templateObject);
var openAnimation = /*#__PURE__*/keyframes(_templateObject2, 'label:openAnimation;');
var Root = /*#__PURE__*/styled('section', {
  target: 'e160cov61',
  label: 'Root'
})(_templateObject3, fontStyles, function (props) {
  return props.width;
}, openAnimation, ANIMATION_DURATION, ANIMATION_EASING);
var Form = /*#__PURE__*/styled('form', {
  target: 'e160cov62',
  label: 'Form'
})(_templateObject4);
var Header = /*#__PURE__*/styled('div', {
  target: 'e160cov63',
  label: 'Header'
})(_templateObject5);
var Title = /*#__PURE__*/styled('h2', {
  target: 'e160cov64',
  label: 'Title'
})(_templateObject6);
var HeaderCancelButton = /*#__PURE__*/styled('button', {
  target: 'e160cov65',
  label: 'HeaderCancelButton'
})(_templateObject7);
var Content = /*#__PURE__*/styled('div', {
  target: 'e160cov66',
  label: 'Content'
})(_templateObject8);
var Buttons = /*#__PURE__*/styled('div', {
  target: 'e160cov67',
  label: 'Buttons'
})(_templateObject9);

var Dialog = function (_PureComponent) {
  _inherits(Dialog, _PureComponent);

  function Dialog() {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || _Object$getPrototypeOf(Dialog)).call(this));

    _this.handleRootRef = function (node) {
      _this.root = node;
    };

    _this.handleFormRef = function (node) {
      _this.form = node;
    };

    _this.handleOverlayClick = function (e) {
      var onCancel = _this.props.onCancel; // Ignore propogated clicks from inside the dialog

      if (onCancel && !_this.root.contains(e.target)) {
        onCancel();
      }
    };

    _this.handleEsc = function (e) {
      var onCancel = _this.props.onCancel; // Esc key

      if (onCancel && e.keyCode === 27) {
        onCancel();
      }
    };

    _this.titleId = nanoid();
    _this.container = document.createElement('div');

    _this.container.setAttribute('data-consent-manager-dialog', '');

    document.body.appendChild(_this.container);
    return _this;
  }

  _createClass(Dialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit,
          title = _props.title,
          children = _props.children,
          buttons = _props.buttons,
          width = _props.width;
      var dialog = React.createElement(Overlay, {
        onClick: this.handleOverlayClick
      }, React.createElement(Root, {
        innerRef: this.handleRootRef,
        role: 'dialog',
        'aria-modal': true,
        'aria-labelledby': this.titleId,
        width: width
      }, React.createElement(Header, null, React.createElement(Title, {
        id: this.titleId
      }, title), onCancel && React.createElement(HeaderCancelButton, {
        onClick: onCancel,
        title: 'Cancel',
        'aria-label': 'Cancel'
      }, "\u2715")), React.createElement(Form, {
        innerRef: this.handleFormRef,
        onSubmit: onSubmit
      }, React.createElement(Content, null, children), React.createElement(Buttons, null, buttons))));
      return ReactDOM.createPortal(dialog, this.container);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var innerRef = this.props.innerRef;
      this.form.querySelector('input,button').focus();
      document.body.addEventListener('keydown', this.handleEsc, false);
      document.body.style.overflow = 'hidden';
      innerRef(this.container);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var innerRef = this.props.innerRef;
      document.body.removeEventListener('keydown', this.handleEsc, false);
      document.body.style.overflow = '';
      document.body.removeChild(this.container);
      innerRef(null);
    }
  }]);

  return Dialog;
}(PureComponent);

Dialog.displayName = 'Dialog';
Dialog.propTypes = {
  innerRef: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  buttons: PropTypes.node.isRequired,
  width: PropTypes.string
};
Dialog.defaultProps = {
  onCancel: undefined,
  width: '750px'
};
export default Dialog;